import { CLIENT_ROLES, COMPANY_FEATURES, PERMISSION_TYPES, isCustomerContactRole } from "@routebot/constants";

export const isCustomerPortalEnabled = (auth) => !!auth?.company?.features?.[COMPANY_FEATURES.CUSTOMER_PORTAL];

const portalPermissionKey = PERMISSION_TYPES.ACCESS_TO_CUSTOMER_PORTAL || "accessToCustomerPortal";

const hasCustomerPortalPermission = (auth) =>
  !!(auth?.permissions?.[portalPermissionKey] || auth?.client?.permissions?.[portalPermissionKey]);

export const canOperateCustomerPortal = (auth) => {
  if (!isCustomerPortalEnabled(auth)) return false;
  if (isCustomerContactRole(auth?.client?.role)) return false;
  const role = auth?.client?.role;
  // Owner/admin may operate by role. Any other teammate (editor, …) operates with the
  // accessToCustomerPortal flag — they do not need to be owner.
  if (role === CLIENT_ROLES.OWNER || role === CLIENT_ROLES.ADMIN) return true;
  return hasCustomerPortalPermission(auth);
};

export { isCustomerContactRole };
